import { Outlet } from 'react-router-dom'
import Header from 'ui/src/components/Header'
import Footer from 'ui/src/components/Footer'
import { ContainerBackground as Container } from 'ui/src/components/Container'
import Box from 'ui/src/components/Box'

const AppRegisterLayout = () => {
  return (
    <>
      <Header />
      <Container
        sx={{
          height: 'fit-content',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'fit-content',
            width: '100%',
            paddingBottom: '20px',
            marginBottom: '30px',
          }}
        >
          <Outlet />
        </Box>
      </Container>
      <Footer />
    </>
  )
}

export default AppRegisterLayout
